module.exports = __webpack_public_path__ + "img/firefox.c22e1241.svg";